import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./module/index";
import store from "../store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

/**
 * 全局前置守卫
 * @param {Object} to 即将要进入的目标
 * @param {Object} from 当前导航正要离开的路由
 * @param {Function} next 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数
 */
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.path === "/login" || to.path === "/") {
    store.dispatch("LogOut")
    next();
    NProgress.done();
  } else {
    console.log(store.getters.userInfo);
    if (store.getters.userInfo == '') {
      next('/');
    } else {
      /* to.path取得地址是否在权限内store.getters.roles 不是跳404 */
      let power = store.getters.roles
      let isPower = power.some(item => item.path == to.path.split('/')[2]);
      console.log(isPower);
      if(isPower){
        next()
      }else{
        if(to.path != '/404'){
          next('/404')
        }
      }
    }
    next()
    NProgress.done();
  }
  // store.dispatch("GetInfo");

  // let isMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)
  window.document.title = to.meta.title || "先进典型";

  // const tokenStr = window.sessionStorage.getItem("token");
  // if (!tokenStr) return next("/login");
});

/**
 * 全局后置钩子
 * @param {Object} to
 * @param {Object} from
 */
router.afterEach((to, from) => {
  NProgress.done();
  //每次切换页面的时候，让页面滚动到最顶部
  window.scrollTo(0, 0);
});

export function createRouter() {
  return router;
}
